import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Tab,
  Tabs,
} from '@mui/material';
import { Person as PersonIcon } from '@mui/icons-material';
import { useAuthStore } from '@store/authStore';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PlayerSelfProgressSection from '@components/dashboard/PlayerSelfProgressSection';
import AccountSubscriptionCard from '@components/subscription/AccountSubscriptionCard';
import DashboardSubscriptionPanel from '@components/subscription/DashboardSubscriptionPanel';
import { brandColors } from '@config/brandTokens';

const CoachDashboard: React.FC = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const dashTab = searchParams.get('tab') === 'subscription' ? 'subscription' : 'overview';

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" component="h1">
            Coach Dashboard
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Welcome, {(user as any)?.firstName || user?.firstName || ''}{' '}
            {(user as any)?.lastName || user?.lastName || ''} ({(user as any)?.coachIdCode || 'N/A'})
          </Typography>
          <Typography variant="body2" sx={{ color: brandColors.slate, mt: 0.75, maxWidth: 560 }}>
            You are a player too — contests and self-eval live under My Learning. More coach tools come later.
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button variant="outlined" startIcon={<PersonIcon />} onClick={() => navigate('/coach/profile')}>
            Profile
          </Button>
          <Button
            variant="outlined"
            onClick={async () => {
              await logout();
              navigate('/login');
            }}
          >
            Logout
          </Button>
        </Box>
      </Box>

      <Tabs
        value={dashTab}
        onChange={(_, next: 'overview' | 'subscription') => {
          const params = new URLSearchParams(searchParams);
          if (next === 'overview') params.delete('tab');
          else params.set('tab', 'subscription');
          setSearchParams(params, { replace: true });
        }}
        sx={{
          mb: 2.5,
          minHeight: 42,
          borderBottom: '1px solid #e2e8f0',
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 800,
            fontFamily: '"Sora", Arial, sans-serif',
            color: brandColors.slate,
            minHeight: 42,
          },
          '& .Mui-selected': { color: `${brandColors.navy} !important` },
          '& .MuiTabs-indicator': { bgcolor: brandColors.navy, height: 3 },
        }}
      >
        <Tab value="overview" label="Overview" />
        <Tab value="subscription" label="Subscription" />
      </Tabs>

      {dashTab === 'subscription' ? (
        <DashboardSubscriptionPanel />
      ) : (
        <>
          <AccountSubscriptionCard />
          <PlayerSelfProgressSection portalMode="coach" title="My Learning Progress" />
        </>
      )}
    </Container>
  );
};

export default CoachDashboard;
